import { createFileRoute } from '@tanstack/react-router';
import { InvoicesPage } from '@/features/accounting/invoices-page';
import { AccountingGuard } from '@/features/accounting/guard';

export const Route = createFileRoute('/_app/accounting/invoices')({ component: () => <AccountingGuard><InvoicesPage /></AccountingGuard> });
